import React from 'react';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import config from 'config';
/* This component is used in
components/common/statsmenu.jsx
components/pages/overview/widgets/widget.jsx
*/
const optionClicked = (props, room) => {
	props.chooseType(room);
}
const RoomTypeSelector = (props) => {
	let singleMode = (props.roomType == 'open_area' || props.roomType == 'meeting_room') &&
		(props.type == 'Meeting rooms' || props.type == 'Open areas');

	return (!singleMode ?
		<Dropdown className={props.className} header={props.type} toggleable>
			<DropdownItem>
				<div onClick={optionClicked.bind(this, props, config.room.MEETINGROOM)}>
					{config.room.MEETINGROOM.type}
				</div>
			</DropdownItem>
			<DropdownItem>
				<div onClick={optionClicked.bind(this, props, config.room.OPENAREA)}>
					{config.room.OPENAREA.type}
				</div>
			</DropdownItem>
			<DropdownItem>
				<div onClick={optionClicked.bind(this, props, config.room.ALLAREA)}>
					{config.room.ALLAREA.type}
				</div>
			</DropdownItem>
		</Dropdown>
		:
		<div className={`dropdown-default-text ${props.className}`}>{props.type}</div>
	);
}
export default RoomTypeSelector



// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/roomtypeselector/index.jsx